import gql from 'graphql-tag';

import { executeGqlMutation } from 'src/graphql/client';
import { getSingleProp } from 'src/lib/graphql';
import type {
  BackendMultiPromptInputs,
  BackendMutationCreateMultiPromptInputsArgs,
} from 'src/types/backend';

import { FRAGMENT_MULTI_PROMPT_INPUTS } from './schema';

const MUTATION = gql`
  mutation CreateMultiPromptInputs($customerId: ID!, $description: String!) {
    createMultiPromptInputs(customerId: $customerId, description: $description) {
      ...MultiPromptInputs
    }
  }
  ${FRAGMENT_MULTI_PROMPT_INPUTS}
`;

type Variables = BackendMutationCreateMultiPromptInputsArgs;
type Result = BackendMultiPromptInputs;

export const createMultiPromptInputs = async (variables: Variables) => {
  const response = await executeGqlMutation({
    mutation: MUTATION,
    variables,
    options: {
      traceAcRequests: true,
    },
  });
  return getSingleProp<Result>(response.data);
};
